import { f as n } from "./index743.mjs";
import { d as o } from "./index740.mjs";
var a = n, v = o, t = Date.prototype, i = "Invalid Date", e = "toString", u = a(t[e]), f = a(t.getTime);
String(/* @__PURE__ */ new Date(NaN)) !== i && v(t, e, function() {
  var r = f(this);
  return r === r ? u(this) : i;
});
